module.exports = __webpack_public_path__ + "assets/img/水果外卖.fdc85009.png";